import { AfterViewInit, Component, Inject, OnDestroy, OnInit } from '@angular/core';

import { Subscription } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { DynamicScriptLoaderService } from '../../core/services';
import { DOCUMENT } from '@angular/common';

declare var Curator: any;

@Component({
  selector: 'gs-social',
  templateUrl: './social.component.html',
  styleUrls: ['./social.component.scss'],
  standalone: false
})
export class SocialComponent implements OnInit, OnDestroy, AfterViewInit {
  private subscriptions: Subscription[] = [];
  private socialWidget: any;

  constructor(
    private dynamicScriptLoaderService: DynamicScriptLoaderService,
    @Inject(DOCUMENT) private document: Document
  ) {
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.subscriptions.push(
      this.dynamicScriptLoaderService
        .loadStyle('https://cdn.curator.io/4.0/css/curator.css')
        .pipe(mergeMap(() => this.dynamicScriptLoaderService
          .loadScript('https://cdn.curator.io/4.0/js/curator.js')))
        .subscribe(() => {
          setTimeout(() => {
            this.startSocialWidget();
          });
        })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
    this.stopSocialWidget();
  }

  /**
   * https://curator.io/docs/widgets
   *
   * @private
   * @memberof HomeComponent
   */
  private startSocialWidget() {
    this.socialWidget = new Curator.Widgets.Waterfall({
      container: '#curator-feed',
      lang: 'en',
      debug: false,
      hidePoweredBy: true,
      forceHttps: false,
      feed: {
        id: '4e6e6ed8-ed58-4868-bd88-a767c601d517',
        apiEndpoint: 'https://api.curator.io',
        postsPerPage: 12,                       // not used any more
        params: {},
        limit: 50,
        showAds: false
      },
      widget: {
        autoLoadNew: true,
        template: 'widget-waterfall',
        colWidth: 300,
        colGutter: 0,
        showLoadMore: true,
        continuousScroll: true,
        postsPerPage: 12,
        animate: true,
        progressiveLoad: true,
        lazyLoad: false,
      },
      post: {
        showTitles: false,
        showShare: true,
        showComments: false,
        showLikes: false,
        autoPlayVideos: false,
        clickAction: 'open-popup',             // open-popup | goto-source | nothing
        clickReadMoreAction: 'open-popup',     // open-popup | goto-source | nothing
        template: 'post-general',
        animate: true,
        maxHeight: 0
      },
      popup: {
        template: 'popup',
        templateWrapper: 'popup-wrapper',
        autoPlayVideos: false,
        deepLink: false,
      },
      filter: {
        template: 'filter',
        showNetworks: false,
        showSources: false,
        showAll: false,
        default: "all",
        limitPosts: false,
        limitPostNumber: 0,
        period: "",
      }
    });

    this.socialWidget.on(Curator.Events.FEED_LOADED, (e, response) => {
      if (response && response.posts) {
        this.socialWidget.feed._feed = this.socialWidget.feed._feed.filter(x =>
          (!x.text || x.text.toUpperCase() != "POWERED BY CURATOR.IO") &&
          (!x.user_screen_name || x.user_screen_name != "curator_io") &&
          (!x.user_full_name || x.user_full_name != "Curator.io")
        );
      }

      const loadMoreElement = this.document.querySelector('.crt-load-more span');
      if (loadMoreElement != null) {
        loadMoreElement.innerHTML = 'Mai multe';
      }
    });
  }

  private stopSocialWidget() {
    if (this.socialWidget) {
      this.socialWidget.destroy();
    }
  }

}
